/**
* Dictionary model 
*/
export interface Dictionary {
	name: string;
	values: Lookup[];
}

/**
* Model for dictionary values
*/
export interface Lookup {
	id: number;
	value: string;
	otherInfo?: string;
}

export const DICTIONARY_NAME_USSTATE = 'USState';
